import { primaryLight, primaryDark } from '@/theme/tokens/base/colors'
import type { AliasTokens, SemanticColors } from '@/theme/types'

/**
 * Creates semantic colors from alias tokens.
 * 
 * CRITICAL: Light theme uses #722fa2 derived shades.
 * Dark theme uses #9B6BFF derived shades.
 * These are fully isolated and never override each other.
 */
export const createSemanticColors = (alias: AliasTokens, mode: 'light' | 'dark' = 'light'): SemanticColors => {
  return {
    primary: alias.brandPrimary, // #722fa2 for light, #9B6BFF for dark
    primaryHover: mode === 'dark' ? primaryDark[400] : primaryLight[600], // Darker shade for hover in light theme
    primaryActive: mode === 'dark' ? primaryDark[600] : primaryLight[700], // Even darker for active state
    surface: alias.brandSurface,
    surfaceElevated: alias.brandSurface,
    background: alias.brandBackground,
    border: alias.brandBorder,
    textPrimary: alias.brandText,
    textSecondary: alias.brandTextMuted,
    textMuted: alias.brandTextMuted,
    // Text tokens based on background brightness
    textOnPrimary: '#FFFFFF', // Always white on primary background
    textOnSurface: mode === 'dark' ? '#F9FAFB' : '#111827', // Dark text on light surface, light on dark
    textOnElevatedSurface: mode === 'dark' ? '#F9FAFB' : '#111827',
    textOnLight: '#111827', // Dark text for light backgrounds
    textOnDark: '#F9FAFB', // Light text for dark backgrounds
    iconPrimary: alias.brandText,
    iconMuted: alias.brandTextMuted,
    error: '#EF4444',
    warning: '#F59E0B',
    success: '#10B981',
    info: '#3B82F6',
  }
}

